// extracted by mini-css-extract-plugin
module.exports = {"base":"card-platform-gray_base___odWU","icon":"card-platform-gray_icon__oa1mi","p":"card-platform-gray_p__nJolC","explore":"card-platform-gray_explore__f57Ni"};